module.exports = __webpack_public_path__ + "e697c2060ecb6a42c33ec1b887c52a50.png";